import { createContext, type FC, type PropsWithChildren, useContext, useState } from "react";

export const NavHeaderContext = createContext<{
  container: Element | null;
  setContainer: (el: HTMLElement | null) => void;
}>({ container: null, setContainer: () => {} });

export const NavHeaderProvider: FC<PropsWithChildren> = ({ children }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  return (
    <NavHeaderContext.Provider value={{ container, setContainer }}>
      {children}
    </NavHeaderContext.Provider>
  );
};

export const NavHeaderSlot: FC = () => {
  const { setContainer } = useContext(NavHeaderContext);

  return <div ref={setContainer} className="min-w-0 flex-1" />;
};
